import { CustomEpicIcon, CustomNumberIcon, CustomTypeIcon } from '@sketchnote/icons';
import { EpicCell } from 'src/features/scrum/components/epic/EpicCell';
import { StoryCell } from 'src/features/scrum/components/sprint/StoryCell';
import { TypeCell } from 'src/features/scrum/components/task/TypeCell';
import { useAgileStore } from 'src/features/scrum/store';

export const AgileFields = ({ task }: { task: any }) => {
  const { isEpic } = useAgileStore();
  return (
    <>
      <div className="flex flex-col">
        <div className="flex py-2 rounded-sm items-center">
          <button
            className="chakra-menu__menu-button inline-block css-1eqi7qs"
            id="menu-button-176"
            aria-expanded="false"
            aria-haspopup="menu"
            aria-controls="menu-list-176"
          >
            <span className="css-xl71ch">
              <div className="flex items-center cursor-pointer gap-8">
                <CustomTypeIcon className="text-gray-400 mr-10" size={24} />

                <input
                  disabled
                  className="mr-10 text-sm text-gray-600 font-regular bg-white placeholder-gray-500  w-126 truncate"
                  placeholder="Field :"
                  defaultValue="Type:"
                />
              </div>
            </span>
          </button>

          <TypeCell task={task} />
        </div>
        <div className="flex py-2 rounded-sm items-center">
          <button
            className="chakra-menu__menu-button inline-block css-1eqi7qs"
            id="menu-button-176"
            aria-expanded="false"
            aria-haspopup="menu"
            aria-controls="menu-list-176"
          >
            <span className="css-xl71ch">
              <div className="flex items-center cursor-pointer">
                <CustomNumberIcon className="text-gray-400 mr-10" size={24} />

                <input
                  disabled
                  className="mr-10 text-sm text-gray-600 font-regular bg-white placeholder-gray-500  w-126 truncate"
                  placeholder="Field :"
                  defaultValue="Story points:"
                />
              </div>
            </span>
          </button>
          <StoryCell task={task} />
        </div>
        {!isEpic && !task.isSubtask && (
          <div className="flex py-2 rounded-sm items-center">
            <button
              className="chakra-menu__menu-button inline-block css-1eqi7qs"
              id="menu-button-176"
              aria-expanded="false"
              aria-haspopup="menu"
              aria-controls="menu-list-176"
            >
              <span className="css-xl71ch">
                <div className="flex items-center cursor-pointer gap-8">
                  <CustomEpicIcon className="text-gray-400 mr-10" size={24} />
                  <input
                    disabled
                    className="mr-10 text-sm text-gray-600 font-regular bg-white placeholder-gray-600  w-126 truncate"
                    placeholder="Field :"
                    defaultValue="Epic"
                  />
                </div>
              </span>
            </button>
            <EpicCell task={task} />
          </div>
        )}
      </div>
    </>
  );
};
